import { useState } from "react";
import { PageHeader, PageHeaderTab } from "../../components/PageHeader";
import { ArticlesTab } from "./components/ArticlesTab";
import { ArticleCategoriesTab } from "./components/ArticleCategoriesTab";
import { WorkTypesTab } from "./components/WorkTypesTab";

type CatalogoTab = "artigos" | "categorias" | "tiposObra";

export function CatalogoView() {
  const [activeTab, setActiveTab] = useState<CatalogoTab>("artigos");

  return (
    <div className="flex flex-col h-full">
      <PageHeader
        title="Catálogo"
        subtitle="Catálogo base de artigos, categorias e tipos de obra"
        tabs={
          <>
            <PageHeaderTab
              label="Artigos"
              isActive={activeTab === "artigos"}
              onClick={() => setActiveTab("artigos")}
            />
            <PageHeaderTab
              label="Categorias"
              isActive={activeTab === "categorias"}
              onClick={() => setActiveTab("categorias")}
            />
            <PageHeaderTab
              label="Tipos de obra"
              isActive={activeTab === "tiposObra"}
              onClick={() => setActiveTab("tiposObra")}
            />
          </>
        }
      />

      <div className="flex-1 overflow-y-auto p-4 md:p-6 bg-background">
        {activeTab === "artigos" && <ArticlesTab />}
        {activeTab === "categorias" && <ArticleCategoriesTab />}
        {activeTab === "tiposObra" && <WorkTypesTab />}
      </div>
    </div>
  );
}
